
    import Vue from "vue";

    const END_POINT = "/medicalAlert";

    const getMedicalAlert = id => Vue.axios.get(END_POINT + "/" + id);

    const getAllMedicalAlerts = data => Vue.axios.get(END_POINT, {params: data});

    const createMedicalAlert = medicalAlert => Vue.axios.post(END_POINT,  medicalAlert );

    const createAllMedicalAlerts = MedicalAlerts => Vue.axios.post(END_POINT + "/all",  MedicalAlerts );

    const updateMedicalAlert = medicalAlert => Vue.axios.put(END_POINT  + "/" + medicalAlert.id,  medicalAlert );

    const deleteMedicalAlert = id => Vue.axios.delete(END_POINT  + "/" + id);

    export {
      getMedicalAlert,
      getAllMedicalAlerts,
      createMedicalAlert,
      createAllMedicalAlerts,
      updateMedicalAlert,
      deleteMedicalAlert
    };
    